import _ from "lodash";
import { START_LOADING, END_LOADING} from "../actions/loadingActions";

export default function(state = {}, action) {
    switch (action.type) {
        case START_LOADING:
            return { ...state, loading: true};
        case END_LOADING:
            return { ...state, loading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/loading_reducer.js